import React from 'react';
import { useNavigate } from 'react-router-dom';
import UserDropdown from './UserDropdown';
import './PageHeader.css';

interface PageHeaderProps {
  title: string;
  showBackButton?: boolean;
  backTo?: string;
  username: string;
  isSuperuser?: boolean;
  onLogout: () => void;
  onManageKnowledge?: () => void;
  onManageUsers?: () => void;
  theme?: 'light' | 'dark';
  rightContent?: React.ReactNode; // For custom content like connection status
}

const PageHeader: React.FC<PageHeaderProps> = ({
  title,
  showBackButton = false,
  backTo,
  username,
  isSuperuser = false,
  onLogout,
  onManageKnowledge,
  onManageUsers,
  theme = 'light',
  rightContent,
}) => {
  const navigate = useNavigate();

  const handleBack = () => {
    if (backTo) {
      navigate(backTo);
    } else {
      navigate(-1);
    }
  };

  return (
    <header className={`page-header ${theme}`}>
      <div className="page-header-content">
        <div className="page-header-left">
          {showBackButton && (
            <button onClick={handleBack} className="back-button" aria-label="Go back">
              ← Back
            </button>
          )}
          <h1 className="page-header-title">{title}</h1>
        </div>

        <div className="page-header-right">
          {rightContent}
          <UserDropdown
            username={username}
            isSuperuser={isSuperuser}
            onLogout={onLogout}
            onManageKnowledge={onManageKnowledge}
            onManageUsers={onManageUsers}
            theme={theme}
          />
        </div>
      </div>
    </header>
  );
};

export default PageHeader;
